import React from 'react';
import { BreadCrumbs, Col, ComponentWithProps, Container, Row } from '@visalex/core';

import cx from 'clsx';

import { FAQPageType } from '../../types';
import { MostFrequentlyAsked } from '../MostFrequentlyAsked/MostFrequentlyAsked';

export const FAQPage: ComponentWithProps<FAQPageType> = ({
  children,
  listOfFaq,
  showBreadCrumbs = false,
  breadcrumbs,
  currentPath,
}) => {
  return (
    <Container>
      {showBreadCrumbs && (
        <Row>
          <BreadCrumbs breadcrumbs={breadcrumbs} />
        </Row>
      )}
      <Row>
        <Col xs={12} lg={7} xl={8} className="order-lg-0 order-1">
          {children}
        </Col>
        <Col xs={12} lg={5} xl={4} className={cx('order-lg-1', 'order-0')}>
          <MostFrequentlyAsked posts={listOfFaq} currentPath={currentPath} />
        </Col>
      </Row>
    </Container>
  );
};
